class AjaxForm extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
        this.submit = this.querySelector('[type="submit"]');
    }

    connectedCallback() {
        this.submit.addEventListener("click", (e) => this.onSubmit(e));
    }

    //takes form as argument to use it in onload function 
    onSubmit(e) {
        e.preventDefault(); // Prevent default form submission

        // Capture form data
        const formData = new FormData(this.form);

        // Send AJAX request
        const xhr = new XMLHttpRequest();
        xhr.open('POST', this.form.action); // Set the request method and URL from the form

        xhr.onload = function () {
            if (xhr.status === 200) {
                console.log('Form submitted successfully!');
            } else {
                console.error('Error submitting form:', xhr.statusText);
            }
        };

        xhr.send(formData);
    }

}

customElements.define("ajax-form", AjaxForm);